<div class="container-fluid">
    <div class="row">
     
      <div class="contact-details opensans-semi-bold-sapphire-10px">
        <h5><span style="padding-right:10px"  class="opensans-semi-bold-sapphire-30px">{{lblHeading}}</span></h5>
      </div>
    </div>
    <hr />
  
    <div class="row" style="margin-top:20px;margin-left:0px;margin-right:0px;padding:0px;">
      <div class="col-md-12" style="margin:0px;padding:0px;">
        <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
         
          <div class="row">
            <div class="col-md-6">
              <div class="row">
                <div class="form-group col-md-12">
                    <div class="first-name ">
                      <span class=""> 
                        Device Id
                      </span>
                    </div>
                  <input type="text" name="device_id" formControlName="device_id" class="form-control form-control-sm"
                         [ngClass]="{'error':form.controls.device_id.invalid && form.controls.device_id.dirty, 'noerror': form.controls.device_id.valid && form.controls.device_id.dirty}"
                         title="device_ids must be unique. Main sort order if group_device_id and sort_order not used." />
                  <div class="form-control-feedback text-danger text-small"
                       *ngIf="form.controls.device_id.invalid && form.controls.device_id.dirty">
                    <p *ngIf="form.controls.device_id.errors.required">Device Id is required</p>
                  </div>
                </div>
                
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="form-group col-md-12">
                  <div class="first-name ">
                    <span class=""> 
                      Scanner Alias
                    </span>
                  </div>
                  <input type="text"  class="form-control" name="scanner_alias" formControlName="scanner_alias" [ngClass]="{'error':form.controls.scanner_alias.invalid && form.controls.scanner_alias.dirty, 'noerror': form.controls.scanner_alias.valid && form.controls.scanner_alias.dirty}" title="Free text scanner_alias of the entity occurrence." />
                  <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.scanner_alias.invalid && form.controls.scanner_alias.dirty">
                    <p *ngIf="form.controls.scanner_alias.errors.required">scanner_alias is required</p>
                    <p *ngIf="form.controls.scanner_alias.errors.maxlength">scanner_alias must not be more than 100 characters.</p>
                  </div>
                </div>
 
              </div>
            </div>
            <!--ScannerIPAddress-->
            <div class="col-6" style="margin:5px auto;">
              <div class="row">
                <div class="form-group col-md">
                  <div class="first-name ">
                    <span class=""> 
                      Scanner IP Address 
                    </span>
                  </div>
                  <input type="text" name="scanner_ip_address" formControlName="scanner_ip_address" class="form-control"
                         [ngClass]="{'error':form.controls.scanner_ip_address.invalid && form.controls.scanner_ip_address.dirty, 'noerror': form.controls.scanner_ip_address.valid && form.controls.scanner_ip_address.dirty}"
                         title="Scanner IP Address" />
                  <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.scanner_ip_address.invalid && form.controls.scanner_ip_address.dirty">
                    <p *ngIf="form.controls.scanner_ip_address.errors.required">Scanner IP Address is required</p>
                  </div>
                </div>
                
  
              </div>
              
            </div>
            <div class="col-6" style="margin:5px auto;">
                <div class="row">
                  <div class="form-group col-md">
                    <div class="first-name ">
                      <span class=""> 
                        PC IP Address 
                      </span>
                    </div>
                    <input type="text" name="pc_ip_address" formControlName="pc_ip_address" class="form-control"
                           [ngClass]="{'error':form.controls.pc_ip_address.invalid && form.controls.pc_ip_address.dirty, 'noerror': form.controls.pc_ip_address.valid && form.controls.pc_ip_address.dirty}"
                           title="PC IP Address" />
                    <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.pc_ip_address.invalid && form.controls.pc_ip_address.dirty">
                      <p *ngIf="form.controls.pc_ip_address.errors.required">Scanner IP Address is required</p>
                    </div>
                  </div>
                  
    
                </div>
                
              </div>
            <!--End Rearrangement-->
  
          
  
                  <!-- Sorting and Displaying -->
                  
                  <!-- End of Sorting and Displayings -->
  
            <div class="col-md-12" style="margin-top:10px;padding-top:10px; font-size:11px;">
              <dl style="width:460px;">
                <dt style="width:40px;">Created </dt>
                <dd [innerHTML]="audit.created"></dd>
                <dt style="width:46px;">Updated </dt>
                <dd [innerHTML]=" audit.updated"></dd>
              </dl>
            </div>
  
          </div>

          
          
          <!-- End -->
  
          
          <div class="col-md-12">
            <br>
            <button title="Save change(s)" type="submit" id="btnSave" [disabled]="!form.valid"
                    class="btn-add_2 btn pull-right" style="width:10%; margin-left:10px; padding: 11px 100px!important;">
              
              Save
            </button>
            <button title="Go Back" type="button" id="btnCancel" [routerLink]="['/scanner/list']"
             class="btn-outline-custom btn pull-right" style="width:10%; margin-left:10px; padding: 11px 100px!important;">
              Back
            </button>
          </div>
        </form>
        <br>
        <br>
        <hr>
        
    </div>
  </div>  
  </div>
  <!--End Container -->
  

